module.exports = __webpack_public_path__ + "media/images/icons/flags/KZ-82d8002057b8a0841190de6c1d248492.svg";